import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import { FormTypesData } from '../../../../domains/common.domain';
import { CommonService } from '../../../../services/common.service';
import { AllDropdownKeys } from '../../../jurisdiction.constants';
import { LookupOptionsData } from '../../../jurisdiction.domain';
import { FacilitiesFormService } from '../../facilities-form.service';
import { EnvironmentService } from 'src/app/services/environment.service';

@Component({
  selector: 'app-new-facility',
  styleUrls: ['./new-facility.component.scss'],
  templateUrl: './new-facility.component.html',
})
export class NewFacilityComponent implements OnInit {
  @Input() currentFormType: FormTypesData;
  @Input() isReadOnly: boolean = false;
  @Input() newFacilityData: any = null;

  formSubscription: Subscription;
  measuringPointKey: string;
  measuringPointOperators: LookupOptionsData[];
  newFacilityFG: FormGroup;

  constructor(
    private commonService: CommonService,
    private facilitiesFormService: FacilitiesFormService,
    public environmentService: EnvironmentService
  ) {
    this.measuringPointKey = AllDropdownKeys.MeasuringPointOperator;
  }

  ngOnInit(): void {
    this.measuringPointOperators = this.commonService.getDropdownData(this.measuringPointKey);
    this.prepareForm();

    this.facilitiesFormService.registerForComponentFormUpdate.next({
      component: 'newFacility',
      formData: this.newFacilityFG,
    });
    this.facilitiesFormService.registerForActionOnFormSubmit.subscribe((value: boolean) => {
      if (value) {
        this.resetData();
      }
    });
  }

  get showMeasuringPointNote(): boolean {
    return this.environmentService.showMeasuringPointNote;
  }

  get getMeasuringPointOperator(): string {
    return this.newFacilityFG.getRawValue()?.measuringPointOperator ?? '';
  }

  prepareForm(): void {
    this.newFacilityFG = new FormGroup({
      installationId: new FormControl(this.newFacilityData?.installationId ?? ''),
      measuringPointOperator: new FormControl(this.newFacilityData?.measuringPointOperator ?? '', [Validators.required]),
      company: new FormControl(this.newFacilityData?.company ?? ''),
    });

    this.formSubscription = this.newFacilityFG.valueChanges.subscribe(() => {
      this.facilitiesFormService.manageComponentFormUpdate({
        component: 'newFacility',
        formData: this.newFacilityFG,
      });
    });
  }

  onOperatorChange(event): void {
    if (event.value === 'other') {
      this.newFacilityFG.controls.company.setValidators([Validators.required]);
    } else {
      this.newFacilityFG.controls.company.setValue('');
      this.newFacilityFG.controls.company.clearValidators();
    }
    this.newFacilityFG.controls.company.updateValueAndValidity();
  }

  private resetData(): void {
    this.formSubscription.unsubscribe();
    this.prepareForm();
  }

  isValid(): boolean {
    return this.newFacilityFG.valid;
  }

  get hideMeasuringPointOperator(): boolean {
    return this.environmentService.hideNewFacilityData && this.currentFormType.key === 'water';
  }
}
